import React from 'react';
import { formatDate, formatDateTime } from '../../utils/date';

export default function DateDisplay({ value, withTime = false, className = '' }) {
  if (!value) return <span className="text-ink-faint">—</span>;
  const formatted = withTime ? formatDateTime(value) : formatDate(value);
  return <span className={`tabular-nums ${className}`}>{formatted}</span>;
}
